export default __webpack_public_path__ + "static/media/Waves Wordmark Large.ff6b06f1.png";